import { VariableValue } from '@components/Variables/types'

import { AutocompleteOption } from '@types'

import { getVariablesHint } from './getVariablesHint'

export const getColumnDialogScript = (data: {
  objectX?: AutocompleteOption
  objectY?: AutocompleteOption
  variables: VariableValue[]
}) => {
  const { objectX, objectY, variables } = data

  return JSON.stringify(
    {
      srcObj: {
        yElement: objectY ? objectY.label : 'ObjectY',
        id: 'string',
        groupId: 'string',
        '[key: string // Column key]': `${objectX ? objectX.label : 'ObjectX'}[]`,
        variables: getVariablesHint(variables),
        startDate: 'string',
        endDate: 'string',
      },
      Object: 'Object',
      Array: 'Array',
      moment: 'moment',
    },
    null,
    '\t'
  )
}
